module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-block"
  }, [_c('h1', [_vm._v("Blog")]), _vm._v(" "), _c('p', [_vm._v("Filter by tags:")]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('span', {
      staticClass: "tag",
      class: [tag === _vm.activeTag ? 'tag--active' : ''],
      on: {
        "click": function($event) {
          _vm.selectTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }))]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return (!_vm.activeTag || post.tags.indexOf(_vm.activeTag) >= 0) ? _c('div', {
      staticClass: "content-block"
    }, [_c('router-link', {
      attrs: {
        "to": post.path
      }
    }, [_c('h3', [_vm._v(_vm._s(post.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.abstract))])])], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31dfc54f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/blog.vue
// module id = 84
// module chunks = 1